/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const PermissionDto = {
    ProcessRead: 'PROCESS_READ',
    ProcessCreate: 'PROCESS_CREATE',
    ProcessEdit: 'PROCESS_EDIT',
    ProcessDelete: 'PROCESS_DELETE',
    ProcessUpdateOwner: 'PROCESS_UPDATE_OWNER',
    ProcessAcceptOverriddenPrice: 'PROCESS_ACCEPT_OVERRIDDEN_PRICE',
    ProcessFilterByUpdateDate: 'PROCESS_FILTER_BY_UPDATE_DATE',
    OfferRead: 'OFFER_READ',
    OfferCreate: 'OFFER_CREATE',
    OfferEdit: 'OFFER_EDIT',
    OfferDelete: 'OFFER_DELETE',
    TaskRead: 'TASK_READ',
    TaskCreate: 'TASK_CREATE',
    TaskEdit: 'TASK_EDIT',
    TaskDelete: 'TASK_DELETE',
    TaskReadAll: 'TASK_READ_ALL',
    TaskEditAll: 'TASK_EDIT_ALL',
    TaskHidden: 'TASK_HIDDEN',
    UserRead: 'USER_READ',
    UserCreate: 'USER_CREATE',
    UserEdit: 'USER_EDIT',
    RoleRead: 'ROLE_READ',
    RoleCreate: 'ROLE_CREATE',
    RoleEdit: 'ROLE_EDIT',
    RoleDelete: 'ROLE_DELETE',
    ContactRead: 'CONTACT_READ',
    ContactCreate: 'CONTACT_CREATE',
    ContactEdit: 'CONTACT_EDIT',
    ContactDelete: 'CONTACT_DELETE',
    ContactManageAll: 'CONTACT_MANAGE_ALL',
    CustomerApprove: 'CUSTOMER_APPROVE',
    ReportsRead: 'REPORTS_READ',
    ReportsDownloadContacts: 'REPORTS_DOWNLOAD_CONTACTS',
    CommissionRead: 'COMMISSION_READ',
    CommissionEdit: 'COMMISSION_EDIT',
    CommissionReadAll: 'COMMISSION_READ_ALL',
    CommissionManageConfiguration: 'COMMISSION_MANAGE_CONFIGURATION',
    CommissionManagePayments: 'COMMISSION_MANAGE_PAYMENTS',
    DictionaryRead: 'DICTIONARY_READ',
    DictionaryCreate: 'DICTIONARY_CREATE',
    DictionaryEdit: 'DICTIONARY_EDIT',
    DictionaryDelete: 'DICTIONARY_DELETE',
    CarRead: 'CAR_READ',
    CarCreate: 'CAR_CREATE',
    CarEdit: 'CAR_EDIT',
    CarDelete: 'CAR_DELETE',
    EmergencyContactRead: 'EMERGENCY_CONTACT_READ',
    EmergencyContactCreate: 'EMERGENCY_CONTACT_CREATE',
    EmergencyContactEdit: 'EMERGENCY_CONTACT_EDIT',
    EmergencyContactDelete: 'EMERGENCY_CONTACT_DELETE',
    SupervisorRead: 'SUPERVISOR_READ',
    SupervisorCreate: 'SUPERVISOR_CREATE',
    SupervisorEdit: 'SUPERVISOR_EDIT',
    SupervisorDelete: 'SUPERVISOR_DELETE',
    AnnouncementRead: 'ANNOUNCEMENT_READ',
    AnnouncementCreate: 'ANNOUNCEMENT_CREATE',
    AnnouncementEdit: 'ANNOUNCEMENT_EDIT',
    AnnouncementDelete: 'ANNOUNCEMENT_DELETE',
    RecurringReservationRead: 'RECURRING_RESERVATION_READ',
    RecurringReservationEdit: 'RECURRING_RESERVATION_EDIT',
    RecurringReservationManageAll: 'RECURRING_RESERVATION_MANAGE_ALL',
} as const;

export type PermissionDto = typeof PermissionDto[keyof typeof PermissionDto];



